import { ComboElement } from './types';
import * as CONST from './constants';
import * as _ from 'lodash-es';

export function getVar(varName: string) {
  return getComputedStyle(document.documentElement).getPropertyValue(varName);
}

export function createEl(parent: Node, name: string) {
  let el;
  if (name.includes('svg')) {
    el = document.createElementNS(CONST.NS.svg, 'svg');
    el.setAttribute('class', 'crt__' + name);
  } else {
    el = document.createElement('div');
    el.className = 'crt__' + name;
  }
  parent.appendChild(el);
  return el;
}

export function passiveEventlistenerOpts() {
  var supportsPassiveOption = false;
  try {
    var opts = Object.defineProperty({}, 'passive', {
      get: function() {
        supportsPassiveOption = true;
      }
    });
    var noop = function() {};
    window.addEventListener('testPassiveEventSupport', noop, opts);
    window.removeEventListener('testPassiveEventSupport', noop, opts);
  } catch (e) {}
  return supportsPassiveOption ? { passive: true } : false;
}

export function convertData(data) {
  let xs = [];
  let pts;
  let dots = [];

  for (let k in data.types) {
    for (let j = 0; j < data.columns.length; j++) {
      if (data.columns[j][0] == k) {
        pts = data.columns[j].slice(1);
      }
    }

    if (data.types[k] === 'x') {
      xs = pts;
    } else if (data.types[k] === 'line') {
      dots.push({
        isActive: true,
        pts: pts,
        name: data.names[k],
        color: data.colors[k]
      });
    }
  }

  return {
    xs,
    pts,
    dots
  };
}

export function getPercent(which, max) {
  const a = which;
  const b = max;
  const c = a / b;
  return c * 100;
}

export function balanceData({ dots, xs }) {
  // todo max by all pts not col
  const maxPTS = Math.max(...dots.map((i) => Math.max(...i.pts)));
  const minPTS = Math.min(...dots.map((i) => Math.min(...i.pts)));

  return {
    dots: dots.map((graph) => {
      return {
        ...graph,
        pts: graph.pts.map((i, idx, col) =>
          getPercent(
            i - minPTS, // TODO opts waterLine
            maxPTS
          )
        )
        // IT'S OK!
        // pts: graph.pts.map((i, idx, col) =>
        //   getPercent(
        //     i - Math.min(...col), // TODO opts waterLine
        //     Math.max(...col)
        //   )
        // )
      };
    }),
    xs: xs.map((i, idx, all) =>
      getPercent(i - all[0], all[all.length - 1] - all[0])
    )
  };
}

export function getPathD({ dots, xs }) {
  let acc = [];

  for (let i = 0; i < dots.pts.length; i++) {
    acc.push(i == 0 ? 'M' : 'L');
    acc.push(xs[i] - xs[0] + ',' + dots.pts[i]);
  }

  return acc;
}

export function createPath(
  svg: Node,
  xs: number[],
  dots: { color: string; pts: string[] },
  id: string
) {
  let isUpdate = document.querySelector('#crt-0 #' + id);

  let line = isUpdate
    ? isUpdate
    : document.createElementNS(CONST.NS.svg, 'path');

  line.setAttribute('d', getPathD({ dots, xs }).join(' ')); // optimize

  if (!isUpdate) {
    line.setAttribute('id', id);
    line.setAttribute('stroke', dots.color);
    line.setAttribute('fill', 'none');
    line.setAttribute('stroke-linejoin', 'round');

    svg.appendChild(line);
  }

  return line;
}

export function formatDate(date: number | Date, tplString: string) {
  date = new Date(date);

  let dateParts = {
    m: date.getMinutes(),
    h: date.getHours(),
    d: date.getDate(),
    D: CONST.WEEKDAYS[date.getDay()],
    M: CONST.MONTHS[date.getMonth()],
    y: date.getFullYear()
  };

  dateParts['T'] = (() => {
    const hh =
      dateParts.h > 9 ? dateParts.h : '0'.concat(dateParts.h.toString());
    const mm =
      dateParts.m > 9 ? dateParts.m : '0'.concat(dateParts.m.toString());

    return `${hh}:${mm}`;
  })();

  return tplString
    .split('')
    .map((i) => dateParts[i] || i)
    .join('');
}

export function formatNumber(n: number) {
  if (n >= 1000000) {
    return (Math.ceil(n / 100000) / 10).toFixed(1) + 'M';
  }
  if (n >= 1000) {
    return (Math.ceil(n / 100) / 10).toFixed(1) + 'K';
  }
  return Math.ceil(n);
}
